import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerTiposTarjeta = async (compania: string) => {
    const params = {
        hash: await getApiHash(),
        compania: compania,
    }
    const headers = {
        "Authorization": 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/getTiposTarjetaJSON", params,
        {
            headers: headers
        }).then(function (response) {
            return response.data.api_data;
        }).catch(function (error) {
            return error;
        });
};

export default obtenerTiposTarjeta;